<script setup lang="ts">
import { ref, watch, computed } from 'vue';
import { useCustomizerStore } from '@/shared/stores/customizer';
import { Icon } from '@iconify/vue';
import { Menu2Icon } from 'vue-tabler-icons';
import LanguageDD from './LanguageDD.vue';
import NotificationDD from './NotificationDD.vue';
import ProfileDD from './ProfileDD.vue';
import Searchbar from './Searchbar.vue';
import WhatsAppButton from '@/shared/components/WhatsAppButton.vue';
import SettingsButton from '@/shared/components/SettingsButton.vue';
import HelpMenu from './HelpMenu.vue';
import Logo from '../logo/Logo.vue';
import RtlLogo from '../logo/RtlLogo.vue';
import LogoIcon from '../logo/LogoIcon.vue';
import Navigations from './Navigations.vue';
import Messages from './Messages.vue';
import RightMobileSidebar from './RightMobileSidebar.vue';
import HeaderInfoBar from './HeaderInfoBar.vue';
import HeaderPlanBadge from './HeaderPlanBadge.vue';
import { isInboxFeatureEnabled } from '@/features/inbox/config/inboxFeature';

const inboxEnabled = isInboxFeatureEnabled();
const customizer = useCustomizerStore();
const showSearch = ref(false);
const priority = ref(customizer.setHorizontalLayout ? 0 : 0);
function searchbox() {
    showSearch.value = !showSearch.value;
}
watch(priority, (newPriority) => {
    priority.value = newPriority;
});


</script>

<template>
    <v-app-bar elevation="5" :priority="priority" height="60" color="primary" class="main-head" id="top">
        <!---LOGO RTL/LTR--->
        <div class="hidden-sm-and-down">
            <!-- 미니 사이드바가 활성화된 경우 항상 LogoIcon 표시 -->
            <div v-if="customizer.mini_sidebar" class="pt-2">
                <LogoIcon />
            </div>
            <!-- 일반 사이드바인 경우 -->
            <template v-else>
                <v-locale-provider v-if="customizer.setRTLLayout" rtl>
                    <div class="pt-2 d-sm-flex d-none">
                        <RtlLogo />
                    </div>
                    <div class="pt-2 pr-2 d-sm-none d-flex">
                        <LogoIcon />
                    </div>
                </v-locale-provider>
                <v-locale-provider v-else>
                    <div class="pt-2 d-sm-flex d-none">
                        <Logo />
                    </div>
                    <div class="pt-2 pr-2 d-sm-none d-flex">
                        <LogoIcon />
                    </div>
                </v-locale-provider>
            </template>
        </div>

        <v-btn
            class="hidden-md-and-down custom-hover-primary menu-toggle"
            size="small"
            icon
            color="primary"
            variant="text"
            @click.stop="customizer.Sidebar_drawer ? customizer.SET_MINI_SIDEBAR(!customizer.mini_sidebar) : customizer.SET_SIDEBAR_VISIBLE(true)"
        >
            <Icon icon="solar:list-bold" height="22" />
        </v-btn>
        <v-btn class="hidden-lg-and-up" icon variant="text" @click.stop="customizer.SET_SIDEBAR_DRAWER" size="small">
            <Icon icon="solar:list-bold" height="22" />
        </v-btn>

        <!-- ---------------------------------------------- -->
        <!-- Search part -->
        <!-- ---------------------------------------------- -->

        <!-- <Searchbar /> -->

        <!-- ---------------------------------------------- -->
        <!-- Mega menu -->
        <!-- ---------------------------------------------- -->
        <!-- <div class="hidden-sm-and-down">
            <Navigations />
        </div> -->

        <!---/Search part -->

        <v-spacer class="hidden-sm-and-down" />
        <!-- ---------------------------------------------- -->
        <!---right part -->
        <!-- ---------------------------------------------- -->
        <!-- ---------------------------------------------- -->
        <!-- Header Info: Language, Date Format, Timezone, Plan -->
        <!-- ---------------------------------------------- -->
        <div class="hidden-sm-and-down d-flex align-center mr-2">
            <HeaderInfoBar />
            <HeaderPlanBadge />
        </div>

        <!-- ---------------------------------------------- -->
        <!-- Action Buttons -->
        <!-- ---------------------------------------------- -->
        <div class="hidden-sm-and-down d-flex align-center">
            <HelpMenu />
            <WhatsAppButton />
            <SettingsButton />
        </div>

        <!-- ---------------------------------------------- -->
        <!-- Mobile Logo -->
        <!-- ---------------------------------------------- -->
        <div class="hidden-md-and-up mt-2">
            <LogoIcon />
        </div>
        <!-- ---------------------------------------------- -->
        <!-- Notification -->
        <!-- ---------------------------------------------- -->
        <div v-if="inboxEnabled" class="hidden-sm-and-down">
            <NotificationDD />
        </div>
        <!-- ---------------------------------------------- -->
        <!-- Messages -->
        <!-- ---------------------------------------------- -->
        <div class="hidden-sm-and-down">
            <Messages />
        </div>

      

        <!-- ---------------------------------------------- -->
        <!-- User Profile -->
        <!-- ---------------------------------------------- -->
        <div class="ms -2 hidden-sm-and-down">
            <ProfileDD />
        </div>

        <!----Mobile ----->
        <v-menu :close-on-content-click="true" class="mobile_popup">
            <template v-slot:activator="{ props }">
                <v-btn icon class="hidden-md-and-up " color="primary" variant="text" v-bind="props" size="small">
                    <Icon icon="solar:menu-dots-bold-duotone" height="22" />
                </v-btn>
            </template>
            <v-sheet rounded="lg" elevation="10" class="mt-4 dropdown-box px-4 py-3">
                <div class="d-flex justify-space-between align-center">
                    <RightMobileSidebar />
                    <HelpMenu />
                    <SettingsButton />
                    <LanguageDD />
                    <NotificationDD v-if="inboxEnabled" />
                    <Messages />
                    <ProfileDD />
                </div>
            </v-sheet>
        </v-menu>
        
    </v-app-bar>
</template>
